<style>
.example-list {
  width: 500px;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.example-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
              0 8px 10px 1px rgba(0, 0, 0, 0.14),
              0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

</style>
<!-- Container-fluid starts -->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <!--<div class="card-header" style="padding:15px;background-color:#e5e5e5">
                    <h5>Add Product Details</h5>
                </div>-->
                <div class="card-body">			
					 <div class="row" style="text-align:center;">
					 <div class="u-pearls-sm row mb-12" style="padding-bottom:10px;">
						<div id="1" class="u-pearl current col-3" >
						  <div class="u-pearl-icon" >1</div><!--<span class="u-pearl-title">Page 1</span>-->
						</div>
						<div id="2" class="u-pearl done col-3">
						  <div class="u-pearl-icon">2</div><!--<span class="u-pearl-title">Page 2</span>-->
						</div>
						<div id="3" class="u-pearl done col-3">
						  <div class="u-pearl-icon">3</div><!--<span class="u-pearl-title">Page 3</span>-->
						</div>	
						<div id="4" class="u-pearl done col-3">
						  <div class="u-pearl-icon">4</div><!--<span class="u-pearl-title">Page 3</span>-->
						</div>							
					  </div>
						
					  
					 </div>
					
					
					<div class="row" id="form1" #form1>
						<form [formGroup]="pForm" class="needs-validation" novalidate>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Categories</h5>
							</div>
							<div class="card-body">
								<div class="row">
									
																		
									<div class="col-md-4 mb-3">
										<label>Category 1 *</label>	
										<select class="form-control select btn-square " formControlName="category1_id" name="category1_id" placeholder="" required (change)="getCategory2($event);" [(ngModel)]="category1_id">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let l1 of l1Categories" value={{l1.level1_id}}>{{l1.level1_name}}</option>                                                                   
										</select>	
											<div *ngIf="pFormClicked  && pForm.controls['category1_id'].errors" >	
												<div *ngIf="pForm.controls['category1_id'].errors?.['required']" class="text text-danger" >Category 1 is required</div>								
											</div>
									</div>
									<div class="col-md-4 mb-3">
										<label>Category 2</label>	
										<select class="form-control select btn-square " formControlName="category2_id" name="category2_id" placeholder="" (change)="getCategory3($event);" [(ngModel)]="category2_id">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let l2 of l2Categories" value={{l2.level2_id}}>{{l2.level2_name}}</option>
										</select>												
									</div>
									<div class="col-md-4 mb-3">
										<label>Category 3</label>	
										<select class="form-control select btn-square " formControlName="category3_id" name="category3_id" placeholder="" [(ngModel)]="category3_id">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let l3 of l3Categories" value={{l3.level3_id}}>{{l3.level3_name}}</option>
										</select>	
									</div>
									
									
									
								</div>   																   																																				
							</div>
						</div>	
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Product Name</h5>
							</div>
							<div class="card-body">								
								<div class="row">										
									<div class="col-md-4 mb-3">
										<label>Brand</label>											
										<select class="form-control select btn-square " formControlName="prod_brand" name="prod_brand" placeholder="" [(ngModel)]="prod_brand">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let b of brands" value={{b.brand_id}}>{{b.brand_name}}</option>
										</select>		
										<div style="text-align:right;"><a class="primary"(click)="openLg(content)" style="cursor:pointer;"> Add New </a></div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Name *</label>
										<input class="form-control btn-square" type="text" formControlName="prod_name" placeholder="" name="prod_name"  required [(ngModel)]="prod_name">
										<div *ngIf="pFormClicked && pForm.controls['prod_name'].errors"  >
											<div *ngIf="pForm.controls['prod_name'].errors?.['required']" class="text text-danger">Product Name is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label>Model</label>	
										<input class="form-control btn-square" type="text" formControlName="prod_model" placeholder="" name="prod_model"  [(ngModel)]="prod_model" >												
									</div>
									<div class="col-md-4 mb-3">
										<label >Colour</label>
										<input class="form-control btn-square" type="text" formControlName="prod_colour" placeholder="" [(ngModel)]="prod_colour"  >											
									</div>	
									<div class="col-md-4 mb-3">
										<label >Packing</label>
										<input class="form-control btn-square" type="text" formControlName="prod_pack" placeholder="" name="prod_pack" [(ngModel)]="prod_pack" >											
									</div>																										
								</div>
										
							</div>
						</div>	
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Manufacturer Details</h5>
							</div>
							<div class="card-body">								
								<div class="row">																			
									<div class="col-md-4 mb-3">
										<label>Manufacturer</label>											
										<select class="form-control select btn-square " formControlName="manu_id" name="manu_id" placeholder="" [(ngModel)]="manu_id" (change)="getManu($event)">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let m of manus" value={{m.manu_id}}>{{m.manu_name}}</option>
										</select>		
										<div style="text-align:right;"><a class="primary"(click)="openLg(manu)" style="cursor:pointer;"> Add New </a></div>
									</div>
									<div class="col-md-4 mb-3" id="origin">
										<label>Country of Origin</label>											
										<select class="form-control select btn-square " formControlName="country_origin" name="country_origin" placeholder="" [(ngModel)]="country_origin">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let m of countries" value={{m.id}}>{{m.countrylong}}</option>
										</select>												
									</div>
																		
								</div>										
							</div>
						</div>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Description *</h5>
							</div>
							<div class="card-body">								
								<div class="row">										
									
									<div class="col-md-12 mb-3">
										<label>Product Description</label>	
										<angular-editor formControlName="prod_description" [(ngModel)]="prod_description" [config]="editorConfig"></angular-editor>											
										<div *ngIf="pFormClicked && pForm.controls['prod_description'].errors"  >
											<div *ngIf="pForm.controls['prod_description'].errors?.['required']" class="text text-danger">Description is required</div>
										</div>
									</div>	
																		
								</div>
										
							</div>
						</div>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Specifications</h5>
							</div>
							<div class="card-body">								
								<div class="row">																			
									<div class="col-md-12 mb-3">
										<label>Product Specifications</label>	
										<angular-editor formControlName="prod_specifications" [(ngModel)]="prod_specifications" [config]="editorConfig"></angular-editor>											
									</div>	
																		
								</div>										
							</div>
						</div>	
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Product summary Image </h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-md-3 mb-3">
										<label >Product Image *</label>
										<input class="form-control btn-square" type="file" formControlName="summary_image_url" placeholder="" name="summary_image_url" (change)="selectFile($event)" >
										<div *ngIf="summary_image_url"><img src={{summary_image_url}}/></div>
										<!--<div *ngIf="logo_upload==''">
										<div *ngIf="next2Clicked  && cForm.controls['logo_upload'].errors" >	
											<div *ngIf="cForm.controls['logo_upload'].errors?.['required']" class="text text-danger" >Logo is required</div>								
										</div>
										</div>-->
									</div>	
									
								</div>
							</div>			
						</div>							
						<form [formGroup]="brandForm" class="needs-validation" novalidate>
							<ng-template #content let-modal>
								<div class="modal-header">
								  <h5 class="modal-title" id="modal-basic-title">Brand >> Add New</h5>
								  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
								</div>
								
								<div class="modal-body">
									<div class="row">
										<div class="col-md-4 mb-3">
											<label>Brand Name *</label>	
											<input class="form-control btn-square"  type="text" placeholder="" name="brand_name" formControlName="brand_name">
											<div *ngIf="onL1Clicked  && brandForm.controls['brand_name'].errors" >	
												<div *ngIf="brandForm.controls['brand_name'].errors?.['required']" class="text text-danger" > Brand Name is required</div>								
											</div>
										</div>									
									</div>											
								</div>
								
								<div class="modal-footer">
								  <button type="button" class="btn btn-outline-dark" (click)="onBrandModel()">Save</button>
								</div>
							</ng-template>
						  </form>
						  <form [formGroup]="manuForm" class="needs-validation" novalidate>
								<ng-template #manu let-modal>
									<div class="modal-header">
									  <h5 class="modal-title" id="modal-basic-title">Manufacturer >> Add New</h5>
									  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
									</div>
									
									<div class="modal-body">
										<div class="row">
											<div class="col-md-4 mb-3">
												<label>Manufacturer Name *</label>	
												<input class="form-control btn-square"  type="text" placeholder="" name="manu_name" formControlName="manu_name" >
												<div *ngIf="manuFormClicked  && manuForm.controls['manu_name'].errors" >	
													<div *ngIf="manuForm.controls['manu_name'].errors?.['required']" class="text text-danger" > Manufacturer Name is required</div>								
												</div>
											</div>									
										</div>	
										<div class="row">
											<div class="col-md-3 mb-3">
												<label>Address Line1</label>	
												<input class="form-control btn-square"  type="text" formControlName="addressline1" placeholder="" name="addressline1" >
											</div>
											<div class="col-md-3 mb-3">
												<label>Address Line2</label>	
												<input class="form-control btn-square"  type="text" formControlName="addressline2" placeholder="" name="addressline2" >
											</div>
											<div class="col-md-3 mb-3">
												<label >Street No</label>
											   <input class="form-control btn-square"  type="text" formControlName="street_no" placeholder="" name="street_no" > 	
											</div>
											<div class="col-md-3 mb-3">
												<label >Street Name</label>
												<input class="form-control btn-square"  type="text" formControlName="street_name" placeholder="" name="street_name" >                                
											</div>									
											<div class="col-md-3 mb-3">
												<label >Area</label>
												<input class="form-control btn-square" type="text" formControlName="area_name" name="area_name" placeholder="" >																							
											</div>
											<div class="col-md-3 mb-3">
												<label >Zip</label>
												<input class="form-control btn-square" type="text" formControlName="zip" placeholder="" name="zip" >                               
												
											</div>
											<div class="col-md-3 mb-3">
												<label >Region</label>
												<input class="form-control btn-square" type="text" formControlName="region_name" name="region_name" placeholder="" >	 
											</div>
											<div class="col-md-3 mb-3">
												<label >Province</label>
												<input class="form-control btn-square" type="text" formControlName="stateshort" name="stateshort" placeholder="" >	 													 										
											</div>
											<div class="col-md-3 mb-3">
												<label >Country *</label>
												<select class="form-control select btn-square " formControlName="countryshort" name="countryshort" placeholder="" [(ngModel)]="country" (change)="getCountry($event);">	
													<option value="">Select</option>                                                                   
													<option *ngFor="let m of countries" value={{m.id}}>{{m.countrylong}}</option>
												</select>
												<div *ngIf="manuFormClicked && manuForm.controls['countryshort'].errors"  >
													<div *ngIf="manuForm.controls['countryshort'].errors?.['required']" class="text text-danger">Country is Required</div>
												</div>		
											</div>
										</div>	
									</div>
									
									<div class="modal-footer">
									  <button type="button" class="btn btn-outline-dark" (click)="onManuModel()">Save</button>
									</div>
								</ng-template>
						  </form>
																				
						<div class="row">                            
							<div class="col-md-12 mb-3" style="text-align:right;">
								<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="clear()">Clear</button>&nbsp;&nbsp;&nbsp;<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(1)">Next</button>									
							</div>									
						</div>
						</form>
						</div>						
						
						
						<div class="row" id="form2" style="display:none" >
							<div class="card" >
								<div class="card-header" style="padding:15px;background-color:#e5e5e5">
									<h5>Product Detailed Page Images and Icons</h5>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-sm-12" style="padding-bottom:10px;">
											<form [formGroup]="PIForm" class="needs-validation" novalidate>
											<ng-template #content4 let-modal>
												<div class="modal-header">
												  <h5 class="modal-title" id="modal-basic-title">Product Image >> Add New</h5>
												  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
												</div>
												<div class="modal-body">
													<div class="row">													
														<div class="col-md-4 mb-3">
															<label>Image *</label>	
															<input class="form-control btn-square"  type="file"  placeholder="" name="images_url" formControlName="images_url" (change)="selectFilePI($event)">
															<div *ngIf="PIFormClicked  && PIForm.controls['images_url'].errors" >	
																	<div *ngIf="PIForm.controls['images_url'].errors?.['required']" class="text text-danger" >Image is required</div>								
															</div>
														</div>													
														<div class="col-md-4 mb-3">
															<label>Order Id *</label>	
															<input class="form-control btn-square"  type="number"  placeholder="" name="order_id" formControlName="order_id">
															<div *ngIf="PIFormClicked  && PIForm.controls['order_id'].errors" >	
																	<div *ngIf="PIForm.controls['order_id'].errors?.['required']" class="text text-danger" >Order Id is required</div>								
															</div>
														</div>
												</div>									
												</div>
												<div class="modal-footer">
												  <button type="button" class="btn btn-outline-dark" (click)="onPIModel()">Save</button>
												</div>
											  </ng-template>
											  </form>
											<a  class="btn btn-primary btn-sm" (click)="openLg(content4)" *ngIf="productImages.length<10"> Add New </a>&nbsp;&nbsp;&nbsp;<!--<a  class="btn btn-primary btn-sm" (click)="openLg(content)"> Reorder </a>-->  
										</div>
									</div>																
								</div>
								<div class="card">
									<div class="card-header">
									  <h5>PRODUCT IMAGE</h5>
									</div>
									<div class="gallery my-gallery card-body row" itemscope="" gallerize>
									  <figure class="col-xl-3 col-sm-6"  *ngFor="let pi of productImages">
										<a  >
										  <img src="{{pi.images_url}}" class="img-fluid" />
										</a>
									  </figure>
									</div>
								  </div>
								<div class="row">                            
									<div class="col-md-12 mb-3" style="text-align:right;">
										<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="back(1)">Back</button>&nbsp;&nbsp;<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(2)">Next</button>									
									</div>									
								</div>	
							</div>																											
						</div>
						
						<div class="row" id="form3" style="display:none">    
						
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Varient Settings</h5>
							</div>
							<div class="card-body">								
								<div class="row">										
									<div class="col-md-4 mb-3">
										<label class="d-block" for="chk-ani2">
											<input id="prod_varient_enabled" type="checkbox" [(ngModel)]="prod_varient_enabled" (click)="onEnableVarient($event)"> Allow Varient											
										</label>										
									</div>										
								</div>
										
							</div>
						</div>	
						<form [formGroup]="priceForm" class="needs-validation" novalidate >																
						<div class="card" id="price">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Price Details</h5>
							</div>
							<div class="card-body">								
								<div class="row">		
									<div class="col-md-3 mb-3">
											<label >Product Price *</label>
											<input class="form-control btn-square" type="number"  placeholder="" name="product_price" formControlName="product_price" required [(ngModel)]="product_price" >	
											<div *ngIf="priceFormClicked && priceForm.controls['product_price'].errors" >	
												<div *ngIf="priceForm.controls['product_price'].errors?.['required']" class="text text-danger" > Product Price required</div>								
											</div>	
									</div>
									<div class="col-md-3 mb-3">
										<label >&nbsp;</label>
										<label class="d-block" for="chk-ani2">
											<input  id="gift_wrapping_enabled" type="checkbox" formControlName="gift_wrapping_enabled" [(ngModel)]="gift_wrapping_enabled" (click)="onEnableGift($event)"> Gift Wrap Allowed											
										</label>										
									</div>	
									<div class="col-md-3 mb-3" style="display:none" id="gift">
											<label >Gift Wrap Price</label>
											<input class="form-control btn-square" type="number"  placeholder="" name="gift_wrapping_price" formControlName="gift_wrapping_price" required [(ngModel)]="gift_wrapping_price">												
									</div>
								</div>
										
							</div>
						</div>	
						
						<div class="card" style="display:none;" id="varient">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Varients Pricing</h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-12" style="padding-bottom:10px;">
										<form [formGroup]="vModelForm" class="needs-validation" novalidate>
										<ng-template #vMForm let-modal>
											<div class="modal-header">
											  <h5 class="modal-title" id="modal-basic-title">Varient >> Add New</h5>
											  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
											</div>
											<div class="modal-body">
											    <div class="row">													
													<div class="col-md-4 mb-3">
														<label>Short Name *</label>	
														<input class="form-control btn-square"  type="text" placeholder="" name="short_name" formControlName="short_name">
														<div *ngIf="vModelFormClicked  && vModelForm.controls['short_name'].errors" >	
														<div *ngIf="vModelForm.controls['short_name'].errors?.['required']" class="text text-danger" > Short Name is required</div>								
													</div>
													</div>
													<div class="col-md-4 mb-3">
														<label>Long Name *</label>	
														<input class="form-control btn-square"  type="text" placeholder="" name="long_name" formControlName="long_name">
														<div *ngIf="vModelFormClicked  && vModelForm.controls['long_name'].errors" >	
														<div *ngIf="vModelForm.controls['long_name'].errors?.['required']" class="text text-danger" > Long Name is required</div>								
													</div>
													</div>
													<div class="col-md-4 mb-3">
														<label>Price *</label>	
														<input class="form-control btn-square"  type="number"  placeholder="" name="product_price" formControlName="product_price">
														<div *ngIf="vModelFormClicked  && vModelForm.controls['product_price'].errors" >	
														<div *ngIf="vModelForm.controls['product_price'].errors?.['required']" class="text text-danger" > Price is required</div>								
														</div>
													</div>
													<div class="col-md-4 mb-3">
														<label>SKU</label>	
														<input class="form-control btn-square"  type="text" placeholder="" name="sku_sellerM" formControlName="sku_sellerM">													
													</div>													
													<div class="col-md-4 mb-3">
														<label>Order Id *</label>	
														<input class="form-control btn-square"  type="number"  placeholder="" name="display_order_id" formControlName="display_order_id">
														<div *ngIf="vModelFormClicked  && vModelForm.controls['display_order_id'].errors" >	
														<div *ngIf="vModelForm.controls['display_order_id'].errors?.['required']" class="text text-danger" > Order ID is required</div>								
													</div>
													</div>
													<div class="col-md-4 mb-3">
														<label class="d-block" for="chk-ani2" >&nbsp;</label>
														<label class="d-block" for="chk-ani2" style="padding-top:10px;">
															<input id="chk-ani2" type="checkbox" formControlName="default_price" [(ngModel)]="default_price"> Default Price										
														</label>										
													</div>		
													<div class="col-md-4 mb-3">
														<label class="d-block" for="chk-ani2" >&nbsp;</label>
														<label class="d-block" for="chk-ani2" style="padding-top:10px;">
															<input id="mgift_wrapping_enabled" type="checkbox" formControlName="gift_wrapping_enabled" [(ngModel)]="gift_wrapping_enabled" (click)="onEnableGiftM($event)"> Gift Wrapping Enabled									
														</label>										
													</div>
													
													
											</div>		
											<div class="row" style="display:none" id="mgift">
												<div class="col-md-4 mb-3">
													<label>Gift Wrapping Price *</label>	
													<input class="form-control btn-square"  type="number"  placeholder="" name="gift_wrapping_priceM" formControlName="gift_wrapping_priceM" [ngModel]="gift_wrapping_priceM">
														<div *ngIf="vModelFormClicked  && vModelForm.controls['gift_wrapping_priceM'].errors" >	
														<div *ngIf="vModelForm.controls['gift_wrapping_priceM'].errors?.['required']" class="text text-danger" > Gift Wrapping Price is Required</div>								
													</div>
												</div>
											</div>											
											</div>
											<div class="modal-footer">
											  <button type="button" class="btn btn-outline-dark" (click)="onPage3()">Save</button>
											</div>
										  </ng-template>
										  </form>
										<a  class="btn btn-primary btn-sm" (click)="openLg(vMForm)"> Add New </a>										
									</div>
								</div>
								<div class="row">
										<form [formGroup]="vEditModelForm" class="needs-validation" novalidate>
												<ng-template #vEditMForm let-modal>
													<div class="modal-header">
													  <h5 class="modal-title" id="modal-basic-title">Varient >> Edit</h5>
													  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
													</div>
													<div class="modal-body">
														<div class="row">													
															<div class="col-md-4 mb-3">
																<label>Short Name *</label>	
																<input class="form-control btn-square"  type="text" placeholder="" name="short_nameEdit" formControlName="short_nameEdit" [(ngModel)]="short_nameEdit">
																<div *ngIf="vEditModelFormClicked  && vEditModelForm.controls['short_nameEdit'].errors" >	
																<div *ngIf="vEditModelForm.controls['short_nameEdit'].errors?.['required']" class="text text-danger" > Short Name is required</div>								
															</div>
															</div>
															<div class="col-md-4 mb-3">
																<label>Long Name *</label>	
																<input class="form-control btn-square"  type="text" placeholder="" name="long_nameEdit" formControlName="long_nameEdit" [(ngModel)]="long_nameEdit">
																<div *ngIf="vEditModelFormClicked  && vEditModelForm.controls['long_nameEdit'].errors" >	
																<div *ngIf="vEditModelForm.controls['long_nameEdit'].errors?.['required']" class="text text-danger" > Long Name is required</div>								
															</div>
															</div>
															<div class="col-md-4 mb-3">
																<label>Price *</label>	
																<input class="form-control btn-square"  type="number"  placeholder="" name="product_priceEdit" formControlName="product_priceEdit" [(ngModel)]="product_priceEdit">
																<div *ngIf="vEditModelFormClicked  && vEditModelForm.controls['product_priceEdit'].errors" >	
																<div *ngIf="vEditModelForm.controls['product_priceEdit'].errors?.['required']" class="text text-danger" > Price is required</div>								
															</div>
															</div>
															<div class="col-md-4 mb-3">
																<label>SKU</label>	
																<input class="form-control btn-square"  type="text" placeholder="" name="sku_sellerEdit" formControlName="sku_sellerEdit" [(ngModel)]="sku_sellerEdit">													
															</div>
															<div class="col-md-4 mb-3">
																<label>Order Id * </label>	
																<input class="form-control btn-square"  type="number"  placeholder="" name="display_order_idEdit" formControlName="display_order_idEdit" [(ngModel)]="display_order_idEdit">
																<div *ngIf="vEditModelFormClicked  && vEditModelForm.controls['display_order_idEdit'].errors" >	
																<div *ngIf="vEditModelForm.controls['display_order_idEdit'].errors?.['required']" class="text text-danger" > Order ID is required</div>								
															</div>
															</div>
															<div class="col-md-4 mb-3" *ngIf="varients.length>1">
																<label class="d-block" for="chk-ani2" >&nbsp;</label>
																<label class="d-block" for="chk-ani2" style="padding-top:10px;">																	
																	<input id="default_priceEdit" type="checkbox" formControlName="default_priceEdit" [(ngModel)]="default_priceEdit" > Default Price										
																</label>										
															</div>	
															<div class="col-md-4 mb-3"  *ngIf="varients.length>1">
																<label class="d-block" for="chk-ani2" >&nbsp;</label>
																<label class="d-block" for="chk-ani2" style="padding-top:10px;">
																	<input type="checkbox" formControlName="item_not_availableEdit" [(ngModel)]="item_not_availableEdit"> Item Not Available									
																</label>										
															</div>
														</div>		
														<div class="row" >
															<div class="col-md-4 mb-3">
																<label class="d-block" for="chk-ani2" >&nbsp;</label>
																<label class="d-block" for="chk-ani2" style="padding-top:10px;">
																	<input id="mgift_wrapping_enabled" type="checkbox" formControlName="gift_wrapping_enabledEdit" (click)="onEnableGiftM($event)" [(ngModel)]="gift_wrapping_enabledEdit"> Gift Wrapping Enabled									
																</label>										
															</div>
															<div class="col-md-4 mb-3" style="{{giftM}}" id="mgift">
																<label>Gift Wrapping Price *</label>	
																<input class="form-control btn-square"  type="number"  placeholder="" name="gift_wrapping_priceEdit" formControlName="gift_wrapping_priceEdit" [(ngModel)]="gift_wrapping_priceEdit">
																<div *ngIf="vEditModelFormClicked  && vEditModelForm.controls['gift_wrapping_priceEdit'].errors" >	
																<div *ngIf="vEditModelForm.controls['gift_wrapping_priceEdit'].errors?.['required']" class="text text-danger" > Gift Wrapping Price is Required</div>								
																</div>
															</div>
														</div>											
												</div>
												<div class="modal-footer">
												  <button type="button" class="btn btn-outline-dark" (click)="onPage3Edit()">Save</button>
												</div>
												  </ng-template>
												  </form>
												  <form [formGroup]="vClosedModelForm" class="needs-validation" novalidate>
														<ng-template #vClosedMForm let-modal>
															<div class="modal-header">
															  <h5 class="modal-title" id="modal-basic-title">Varient >> Disable</h5>
															  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
															</div>
															<div class="modal-body">
																<div class="row">													
																	<div class="col-md-4 mb-3">
																		<label>Disable Reason *</label>	
																			<input class="form-control btn-square"  type="text" placeholder="" name="closed_reason" formControlName="closed_reason" [(ngModel)]="closed_reason">
																			<div *ngIf="vClosedModelFormClicked  && vClosedModelForm.controls['closed_reason'].errors" >	
																		<div *ngIf="vClosedModelForm.controls['closed_reason'].errors?.['required']" class="text text-danger" > Closed Reason is required</div>								
																	</div>
																	</div>																
																</div>																											
															</div>
															<div class="modal-footer">
															  <button type="button" class="btn btn-outline-dark" (click)="onPageClosed()">Save</button>
															</div>
														</ng-template>
												  </form>
								</div>
								<div class="table-responsive">                        											
									<table id="varients" class="table table-bordered table-condensed" datatable >
									  <thead>
										<tr>
											<th >Order Id</th>
											<th >Default</th>
											<th >Short Name</th>
											<th >Long Name</th>				  											
											<th >Price</th>											
											<th >Gift Wrapping</th>	
											<th >Gift Wrapping Price</th>
											<th >Actions</th>
										</tr>
									  </thead>
									  <tbody>
										<tr *ngFor="let v of varients">
											<td>{{v.display_order_id}}</td>
											<td *ngIf="v.default_price==true;else defaultFalse"><i class="fa fa-check-square" style="color:#143fef"></i></td>
											<ng-template #defaultFalse><td><i class="fa fa-square-o" style="color:#143fef"></i></td></ng-template>										 
											<td>{{v.short_name}}</td>
											<td>{{v.long_name}}</td>										  
											<td>{{v.product_price}}</td>
											<td *ngIf="v.gift_wrapping_enabled==true;else giftFalse"><i class="fa fa-check-square" style="color:#143fef"></i></td>
											<ng-template #giftFalse><td><i class="fa fa-square-o" style="color:#143fef"></i></td></ng-template>										  
											<td>{{v.gift_wrapping_price}}</td>
											<td width="20%">
												<span *ngIf="v.closed==false"><a class="btn btn-primary btn-sm" (click)="openLgVarient(vEditMForm,v.varient_id)"> Edit </a></span>
												<span *ngIf="v.default_price!=true">
												<a *ngIf="v.closed==true;else close" class="btn btn-primary btn-sm" (click)="onPageEnbled(v.varient_id)"> Enable </a>
												<ng-template #close>&nbsp;&nbsp;&nbsp;<a class="btn btn-primary btn-sm" (click)="openLgVarientClosed(vClosedMForm,v.varient_id)">Disable</a></ng-template>
												</span >
											</td>										  
										</tr>
									  </tbody>
									</table>						
								</div>
								
							</div>							
						</div>																														
							</form>
														
														
							<form [formGroup]="vForm" class="needs-validation" novalidate >	
							<div class="card">
								<div class="card-header" style="padding:15px;background-color:#e5e5e5">
									<h5>GST and HSN Details </h5>
								</div>
								<div class="card-body">								
									<div class="row">										
										<div class="col-md-3 mb-3">
											<label >CGST *</label>
											<input class="form-control btn-square" type="number"  placeholder="" name="cgst" formControlName="cgst" required [(ngModel)]="cgst">	
											<div *ngIf="vFormClicked  && vForm.controls['cgst'].errors" >	
												<div *ngIf="vForm.controls['cgst'].errors?.['required']" class="text text-danger" > CGST is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label >SGST *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="sgst" formControlName="sgst" required [(ngModel)]="sgst">	
											<div *ngIf="vFormClicked  && vForm.controls['sgst'].errors" >	
												<div *ngIf="vForm.controls['sgst'].errors?.['required']" class="text text-danger" > SGST is required</div>								
											</div>								
										</div>
										<div class="col-md-3 mb-3">
											<label >IGST *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="igst" formControlName="igst"  [(ngModel)]="igst">										
											<div *ngIf="vFormClicked  && vForm.controls['igst'].errors" >	
												<div *ngIf="vForm.controls['igst'].errors?.['required']" class="text text-danger" > IGST is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label >HSN Code </label>
											<input class="form-control btn-square" type="text" placeholder="" name="hsn_code" formControlName="hsn_code"  [(ngModel)]="hsn_code">																					
										</div>
										<div class="col-md-3 mb-3" id="varient1">
											<label >SKU </label>
											<input class="form-control btn-square" type="text" placeholder="" name="sku_seller" formControlName="sku_seller"  [(ngModel)]="sku_seller">																					
										</div>									
									</div>										
								</div>
							</div>
							<div class="row">                            
									<div class="col-md-12 mb-3" style="text-align:right;">
										<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="back(2)">Back</button>&nbsp;&nbsp;<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(3)">Next</button>								
									</div>									
							</div>
						</form>										
						</div> 
						
						<div class="row" id="form4" style="display:none"> 
							<form [formGroup]="discountForm" class="needs-validation" novalidate >
							<div class="card">
								<div class="card-header" style="padding:15px;background-color:#e5e5e5">
									<h5>Standard Discount and Special Offer Discount Settings</h5>
								</div>
								
								<div class="card-body">
									
									<div class="row">																				
										<div class="col-md-3 mb-3">
											<label >Standard Discount Percentage</label>
											<input class="form-control btn-square" type="number" placeholder="" name="discount_percentage" formControlName="discount_percentage" required [(ngModel)]="discount_percentage" (blur)="onDiscount($event)" #dis_per>																		
										</div>
										
										<div class="col-md-3 mb-3">
											<label >Enable Special Offer</label>
											<label class="d-block" >											
											<input  id="special_offer" type="checkbox" formControlName="enable_special_offer" [(ngModel)]="enable_special_offer" (click)="onEnable($event)">
											</label>
										</div>																	
									</div>
									<div style="display:none" id="s_offer">
									<div class="row" >	
										<div class="col-md-3 mb-3">
											<label >special_offer_percentage</label>
											<input class="form-control btn-square" type="number" placeholder="" name="special_offer_percentage" formControlName="special_offer_percentage" [(ngModel)]="special_offer_percentage" readonly>																	
										</div>
										<div class="col-md-3 mb-3">
												<label >Special Offer Start Date</label>
												<input class="form-control btn-square" type="date" placeholder="" name="special_offer_start_date" formControlName="special_offer_start_date"  [(ngModel)]="special_offer_start_date">																		
											</div>
										<div class="col-md-3 mb-3">
											<label >Special Offer Infinite</label>
											<label class="d-block" for="chk-ani2">											
												<input  id="special_offer_infinite" type="checkbox" formControlName="special_offer_infinite" [(ngModel)]="special_offer_infinite" (click)="onInfinite($event)"> 
											</label>
										</div>
											
									</div>
									<div id="infinite">
									<div class="row" >																					
											<div class="col-md-3 mb-3">
												<label >Special Offer End Date</label>
												<input class="form-control btn-square" type="date" placeholder="" name="special_offer_end_date" formControlName="special_offer_end_date"  [(ngModel)]="special_offer_end_date">																					
											</div>		
										</div>
									</div>
									</div>
								</div>
							</div>
							
							</form>
							<div class="card">
								<div class="card-header" style="padding:15px;background-color:#e5e5e5">
									<h5>Bundle Discount Settings</h5>
								</div>
								
								<div class="card-body">
									<div class="row">
										<div class="col-md-4 mb-3">
											<label class="d-block" for="chk-ani2">
												<input id="ebd" type="checkbox" formControlName="enable_bundle_discounts" (click)="onEnableEBD($event)"> Enable Bundle Discounts											
											</label>										
										</div>	
									</div>
								</div>
							</div>
							<div class="card" style="display:none;" id="bd">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Bundle Discount Settings</h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-12" style="padding-bottom:10px;">
										<form [formGroup]="bModelForm" class="needs-validation" novalidate>
										<ng-template #bMForm let-modal>													
													<div class="modal-header">
													  <h5 class="modal-title" id="modal-basic-title">Add Bundle >> Add New</h5>
													  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
													</div>
													<div class="modal-body">
														<div class="row">													
															<div class="col-md-4 mb-3">
																<label>Bundle Product ID</label>	
																<select class="form-control select btn-square " formControlName="bundle_id" name="bundle_id" placeholder="" required style="font-size:14px;">	
																	<option value="">Select</option>                                                                   
																	<option *ngFor="let p of productsList" value={{p.prod_id}}>{{p.prod_name}}</option>                                                                   
																</select>	
																<div *ngIf="bModelFormClicked  && bModelForm.controls['bundle_id'].errors" >	
																	<div *ngIf="bModelForm.controls['bundle_id'].errors?.['required']" class="text text-danger" >Bundle Product ID required</div>								
																</div>
															</div>
															<div class="col-md-4 mb-3">
																<label>Bundle Offer Percentage</label>	
																<input class="form-control btn-square"  type="text" placeholder="" name="bundle_offer_percentage" formControlName="bundle_offer_percentage" style="font-size:14px;">
																<div *ngIf="bModelFormClicked  && bModelForm.controls['bundle_offer_percentage'].errors" >	
																<div *ngIf="bModelForm.controls['bundle_offer_percentage'].errors?.['required']" class="text text-danger" > Bundle Offer Percentage</div>								
															</div>
															</div>													
															<div class="col-md-4 mb-3">
																<label>Order Id</label>	
																<input class="form-control btn-square"  type="number"  placeholder="" name="order_id" formControlName="order_id" style="font-size:14px;">
																<div *ngIf="bModelFormClicked  && bModelForm.controls['order_id'].errors" >	
																<div *ngIf="bModelForm.controls['order_id'].errors?.['required']" class="text text-danger" > Order ID is required</div>								
															</div>
															</div>
													</div>											
													</div>
													<div class="modal-footer">
													  <button type="button" class="btn btn-outline-dark" (click)="onAdd()">Save</button>
													</div>
										  
												  </ng-template>
										  </form>
										<a  class="btn btn-primary btn-sm" (click)="openLg(bMForm)"> Add New </a>										
									</div>
								</div>
								<div class="row">
										<form [formGroup]="bEditModelForm" class="needs-validation" novalidate>
												<ng-template #bEditMForm let-modal>													
													<div class="modal-header">
													  <h5 class="modal-title" id="modal-basic-title">Add Bundle >> Add New</h5>
													  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
													</div>
													<div class="modal-body">
														<div class="row">													
															<div class="col-md-4 mb-3">
																<label>Bundle Product ID</label>	
																<select class="form-control select btn-square " formControlName="bundle_id_edit" name="bundle_id_edit" placeholder="" required  [(ngModel)]="bundle_id_edit" style="font-size:14px;">	
																	<option value="">Select</option>                                                                   
																	<option *ngFor="let p of productsList" value={{p.prod_id}}>{{p.prod_name}}</option>                                                                   
																</select>	
																<div *ngIf="bEditModelFormClicked  && bEditModelForm.controls['bundle_id_edit'].errors" >	
																	<div *ngIf="bEditModelForm.controls['bundle_id_edit'].errors?.['required']" class="text text-danger" >Bundle Product ID required</div>								
																</div>
															</div>
															<div class="col-md-4 mb-3">
																<label>Bundle Offer Percentage</label>	
																<input class="form-control btn-square"  type="text" placeholder="" name="bundle_offer_percentage_edit" formControlName="bundle_offer_percentage_edit" style="font-size:14px;" [(ngModel)]="bundle_offer_percentage_edit">
																<div *ngIf="bEditModelFormClicked  && bEditModelForm.controls['bundle_offer_percentage_edit'].errors" >	
																<div *ngIf="bEditModelForm.controls['bundle_offer_percentage_edit'].errors?.['required']" class="text text-danger" > Bundle Offer Percentage</div>								
															</div>
															</div>													
															<div class="col-md-4 mb-3">
																<label>Order Id</label>	
																<input class="form-control btn-square"  type="number"  placeholder="" name="order_id_edit" formControlName="order_id_edit" style="font-size:14px;" [(ngModel)]="order_id_edit">
																<div *ngIf="bEditModelFormClicked  && bEditModelForm.controls['order_id_edit'].errors" >	
																<div *ngIf="bEditModelForm.controls['order_id_edit'].errors?.['required']" class="text text-danger" > Order ID is required</div>								
															</div>
															</div>
													</div>											
													</div>
													<div class="modal-footer">
													  <button type="button" class="btn btn-outline-dark" (click)="onEdit()">Save</button>
													</div>
										  
												  </ng-template>
												  </form>
												  <!--<form [formGroup]="vClosedModelForm" class="needs-validation" novalidate>
														<ng-template #vClosedMForm let-modal>
															<div class="modal-header">
															  <h5 class="modal-title" id="modal-basic-title">Varient >> Disable</h5>
															  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">  </button>
															</div>
															<div class="modal-body">
																<div class="row">													
																	<div class="col-md-4 mb-3">
																		<label>Disable Reason *</label>	
																			<input class="form-control btn-square"  type="text" placeholder="" name="closed_reason" formControlName="closed_reason" [(ngModel)]="closed_reason">
																			<div *ngIf="vClosedModelFormClicked  && vClosedModelForm.controls['closed_reason'].errors" >	
																		<div *ngIf="vClosedModelForm.controls['closed_reason'].errors?.['required']" class="text text-danger" > Closed Reason is required</div>								
																	</div>
																	</div>																
																</div>																											
															</div>
															<div class="modal-footer">
															  <button type="button" class="btn btn-outline-dark" (click)="onPageClosed()">Save</button>
															</div>
														</ng-template>
												  </form>-->
								</div>
								 <div class="table-responsive" >                        											
									<table id="bundleproductTable" class="table table-bordered table-condensed" datatable >
									  <thead>
										<tr>								
											<th >Order Id</th>				  														
											<th >Product Name</th>				  														
											<th >Bundle Offer Percentage</th>	
											<th >Actions</th>
										</tr>
									  </thead>
									  <tbody>
										<tr *ngFor="let b of bundleproducts">
											<td>{{ b.order_id }}</td>
											<td>{{ b.prod_name }}</td>							  
											<td>{{ b.bundle_offer_percentage }}</td>
											<td width="20%"><a class="btn btn-primary btn-sm" (click)="openLgBundle(bEditMForm,b.bundle_id)"> Edit </a>&nbsp;&nbsp;&nbsp;<a class="btn btn-primary btn-sm" (click)="removeBundle(b.bundle_id)"> Delete </a></td>										  
										</tr>
									  </tbody>
									</table>						
								</div>
								
							</div>							
						</div>
							
							<div class="card">
								<div class="card-header" style="padding:15px;background-color:#e5e5e5">
									<h5>Volume Discounts</h5>
								</div>
								<div class="card-body">								
									<div class="row">										
										<div class="col-md-4 mb-3">
											<label class="d-block" for="chk-ani2">
												<input  id="vd" type="checkbox" name="vd"  (click)="onEnableVD($event)">	Enable Volume Discounts																			
											</label>										
										</div>										
									</div>
											
								</div>
								<form [formGroup]="vdForm" class="needs-validation" novalidate >	
								<div class="card-body" id="vdf" style="display:none;">								
									<div class="row">										
										<div class="col-md-4 mb-3">
											<label >Slab 1 <br> Product Quantity Greatter Then or Equal to *</label>
											<input class="form-control btn-square" type="text"  placeholder="" name="slab1_gte" formControlName="slab1_gte" required [(ngModel)]="slab1_gte" [readonly]="slab1_disable" (blur)="slab1()">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab1_gte'].errors" >	
												<div *ngIf="vdForm.controls['slab1_gte'].errors?.['required']" class="text text-danger" > Slab 1 is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label ><br> Discount Percentage *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="slab1_disc_percentage" formControlName="slab1_disc_percentage" required [(ngModel)]="slab1_disc_percentage">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab1_disc_percentage'].errors" >	
												<div *ngIf="vdForm.controls['slab1_disc_percentage'].errors?.['required']" class="text text-danger" > Slab 1 Discount is required</div>								
											</div>								
										</div>
									</div>
									<div class="row">
										<div class="col-md-4 mb-3">
											<label >Slab 2 <br> Product Quantity Greatter Then or Equal to *</label>
											<input class="form-control btn-square" type="text"  placeholder="" name="slab2_gte" formControlName="slab2_gte" required [(ngModel)]="slab2_gte" [readonly]="slab2_disable" (blur)="slab2($event)">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab2_gte'].errors" >	
												<div *ngIf="vdForm.controls['slab2_gte'].errors?.['required']" class="text text-danger" > Slab 2 is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label ><br>Discount Percentage *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="slab2_disc_percentage" formControlName="slab2_disc_percentage" required [(ngModel)]="slab2_disc_percentage">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab2_disc_percentage'].errors" >	
												<div *ngIf="vdForm.controls['slab2_disc_percentage'].errors?.['required']" class="text text-danger" > Slab 2 Discount is required</div>								
											</div>								
										</div>
																			
									</div>
									
									<div class="row">
										<div class="col-md-4 mb-3">
											<label >Slab 3 <br> Product Quantity Greatter Then or Equal to *</label>
											<input class="form-control btn-square" type="text"  placeholder="" name="slab3_gte" formControlName="slab3_gte" required [(ngModel)]="slab3_gte" [readonly]="slab3_disable" (blur)="slab3($event)">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab3_gte'].errors" >	
												<div *ngIf="vdForm.controls['slab3_gte'].errors?.['required']" class="text text-danger" > Slab 3 is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label ><br>Discount Percentage *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="slab3_disc_percentage" formControlName="slab3_disc_percentage" required [(ngModel)]="slab3_disc_percentage">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab3_disc_percentage'].errors" >	
												<div *ngIf="vdForm.controls['slab3_disc_percentage'].errors?.['required']" class="text text-danger" > Slab 3 Discount is required</div>								
											</div>								
										</div>																	
									</div>
									
									<div class="row">
										<div class="col-md-4 mb-3">
											<label >Slab 4 <br> Product Quantity Greatter Then or Equal to *</label>
											<input class="form-control btn-square" type="text"  placeholder="" name="slab4_gte" formControlName="slab4_gte" required [(ngModel)]="slab4_gte" [readonly]="slab4_disable" (blur)="slab4($event)">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab4_gte'].errors" >	
												<div *ngIf="vdForm.controls['slab4_gte'].errors?.['required']" class="text text-danger" > Slab 4 is required</div>								
											</div>	
										</div>
										<div class="col-md-3 mb-3">
											<label ><br>Discount Percentage *</label>
											<input class="form-control btn-square" type="number" placeholder="" name="slab4_disc_percentage" formControlName="slab4_disc_percentage" required [(ngModel)]="slab4_disc_percentage">	
											<div *ngIf="vdFormClicked  && vdForm.controls['slab4_disc_percentage'].errors" >	
												<div *ngIf="vdForm.controls['slab4_disc_percentage'].errors?.['required']" class="text text-danger" > Slab 4 Discount is required</div>								
											</div>								
										</div>																	
									</div>
									<div class="row">
										<div class="col-md-4 mb-3" style="text-align:right;">
											<a class="primary"(click)="enableSlab()" style="cursor:pointer;">Edit Slab </a>											
										</div>																								
									</div>	
											
								</div>
								</form>
							</div>	
							<div class="row">                            
									<div class="col-md-12 mb-3" style="text-align:right;">
										<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="back(3)">Back</button>&nbsp;&nbsp;<button class="btn btn-primary btn-sm" type="button" placement="top" ngbTooltip="Next" (click)="next(4)">Save</button>								
									</div>									
							</div>							
						</div>
																		
							
																								
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends -->